import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ArrowLeftIcon from "../icon/arrowLeftIcon";
import { addNewRoomData, createNewChargeData } from "../../types/types";
import ArrowRightIcon from "../icon/arrowRightIcon";
import CustomButton from "../common/customButton";
import SpaceComponent from "./spaceComponent";
import { text } from "stream/consumers";
import AddSpaceModal from "./addSpaceModal";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: white;
  border-bottom-left-radius: 1vw;
  border-bottom-right-radius: 1vw;
  box-shadow: 3px 3px 20px -10px #16161642;
`;

const Backdrop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000050;
  z-index: 9998; /* 모달보다 아래에 위치하도록 설정합니다. */
`;

const HeaderAreaWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 87vw;
  height: 100%;
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 8vw;
  margin-top: 2vw;
  margin-bottom: 2vw;
`;

const TitleArea = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  height: 100%;
  width: 30vw;
  font-size: 3.4vw;
  font-weight: 700;
`;

const PagingArea = styled.div`
  width: 26vw;
  height: 5vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const PrevBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 100%;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const NumBox = styled.div`
  width: 13vw;
  height: 100%;
  background-color: #e7e7e7;
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
`;

const NextBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const ButtonArea = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  height: 100%;
  width: 30vw;
`;

const ContentsArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 4vw;
`;

const Line = styled.div`
  width: 100%;
  height: 1vw;
  border-bottom: 0.2vw dashed #d8d8d8;
`;

const AddSpaceButtonBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2vw;
`;

export default function InputItemTab(props: any) {
  const { data, setData, currentPage, setCurrentPage, maxIndex, setMaxIndex } =
    props;

  const [prevBoxActive, setPrevBoxActive] = useState<boolean>(false);
  const [nextBoxActive, setNextBoxActive] = useState<boolean>(false);
  const [openAddSpaceModal, setOpenAddSpaceModal] = useState<boolean>(false);

  const clickPrevPage = (e: any) => {
    if (currentPage <= 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const clickNextPage = (e: any) => {
    if (currentPage >= maxIndex) {
      return;
    }
    setCurrentPage(currentPage + 1);
  };

  const addNewPage = () => {
    if (window.confirm("새로운 페이지를 추가하시겠습니까?")) {
      setData((prev: any) => {
        const updatedData = { ...prev };
        // 마지막 항목의 ID와 새로 추가될 페이지 인덱스를 계산합니다.
        const lastId = data.chargeList[data.chargeList.length - 1].id;
        const newPageIndex = data.chargeList.length + 1;

        // 새 항목을 생성합니다.
        const newChargeData = createNewChargeData(lastId, newPageIndex);
        updatedData.chargeList = [...updatedData.chargeList, newChargeData];
        return updatedData;
      });
      setMaxIndex(maxIndex + 1);
      setCurrentPage(maxIndex + 1);
    }
    return;
  };

  // 새로운 공간을 추가하는 함수
  const addNewSpace = (type: number, typeName: string, name: string) => {
    setData((prev: any) => {
      const updatedData = { ...prev };

      const lastId = updatedData.chargeList[currentPage - 1].roomList.length;

      // 새로 추가될 공간 데이터 생성
      const newData = addNewRoomData(lastId, type, typeName, name);
      updatedData.chargeList[currentPage - 1].roomList = [
        ...updatedData.chargeList[currentPage - 1].roomList,
        newData,
      ];
      return updatedData;
    });
  };

  // id값(index+1)로 특정 공간을 삭제하는 함수
  const deleteSpaceById = (idToRemove: number) => {
    setData((prev: any) => {
      const updatedData = { ...prev };

      // id가 idToRemove와 다른 항목만 필터링
      updatedData.chargeList[currentPage - 1].roomList = updatedData.chargeList[
        currentPage - 1
      ].roomList.filter((item: any) => item.id !== idToRemove);

      return updatedData; // 변경된 데이터를 반환
    });
    reorderRoomIds(); // ID 재정렬 함수 호출
  };

  // id값으로 특정 공간을 배열에서 삭제한 후, 중복되지 않게 id값을 재정렬하는 함수
  const reorderRoomIds = () => {
    setData((prev: any) => {
      const updatedData = { ...prev };

      // 재정렬된 ID로 roomList를 갱신
      updatedData.chargeList[currentPage - 1].roomList = updatedData.chargeList[
        currentPage - 1
      ].roomList.map((item: any, index: number) => {
        return { ...item, id: index + 1 }; // ID를 index+1로 재정렬
      });

      return updatedData; // 변경된 데이터를 반환
    });
  };

  // id값으로 특정 공간을 배열에서 삭제한 후, 중복되지 않게 id값을 재정렬하는 함수
  const reorderItemIds = (roomIdToReorder: number) => {
    setData((prev: any) => {
      const updatedData = { ...prev };

      // 재정렬된 ID로 itemList를 갱신
      updatedData.chargeList[currentPage - 1].roomList[
        roomIdToReorder - 1
      ].itemList = updatedData.chargeList[currentPage - 1].roomList[
        roomIdToReorder - 1
      ].itemList.map((item: any, index: number) => {
        return { ...item, id: index + 1 }; // ID를 index+1로 재정렬
      });
      return updatedData; // 변경된 데이터를 반환
    });
  };

  const deleteItemById = (roomIdToRemove: number, idToRemove: number) => {
    setData((prev: any) => {
      const updatedData = { ...prev };

      updatedData.chargeList[currentPage - 1].roomList[
        roomIdToRemove - 1
      ].itemList = updatedData.chargeList[currentPage - 1].roomList[
        roomIdToRemove - 1
      ].itemList.filter((item: any) => item.id !== idToRemove);

      return updatedData;
    });
    reorderItemIds(roomIdToRemove);
  };

  const onCloseAddSpaceModal = () => {
    setOpenAddSpaceModal(false);
  };

  useEffect(() => {
    if (maxIndex === 1) {
      return;
    }
    if (currentPage <= 1) {
      setPrevBoxActive(false);
      setNextBoxActive(true);
    } else {
      setPrevBoxActive(true);

      if (currentPage >= maxIndex) {
        setNextBoxActive(false);
      } else {
        setNextBoxActive(true);
      }
    }
  }, [currentPage, maxIndex]);

  return (
    <>
      <Wrapper>
        <HeaderAreaWrapper>
          <HeaderArea>
            <TitleArea>
              물품 정보{data.chargeList[currentPage - 1].id}
            </TitleArea>
            <PagingArea>
              <PrevBox $isActivate={prevBoxActive}>
                <ArrowLeftIcon
                  onClick={(e: any) => clickPrevPage(e)}
                  width={"4.2vw"}
                  height={"4.2vw"}
                  fill={"white"}
                />
              </PrevBox>
              <NumBox>
                {currentPage} / {maxIndex}
              </NumBox>
              <NextBox $isActivate={nextBoxActive}>
                <ArrowRightIcon
                  onClick={(e: any) => clickNextPage(e)}
                  width={"4.2vw"}
                  height={"4.2vw"}
                  fill={"white"}
                />
              </NextBox>
            </PagingArea>
            <ButtonArea>
              <CustomButton
                width="20vw"
                height="5vw"
                size="2.2vw"
                fontWeight="300"
                text="+ 페이지 추가"
                onClick={addNewPage}
                radius="0.6vw"
              ></CustomButton>
            </ButtonArea>
          </HeaderArea>
        </HeaderAreaWrapper>
      </Wrapper>
      <ContentsArea>
        {data.chargeList[currentPage - 1].roomList.length > 0 &&
          data.chargeList[currentPage - 1].roomList.map(
            (item: any, index: number) => {
              return (
                <SpaceComponent
                  key={item.id}
                  data={item}
                  setData={setData}
                  currentPage={currentPage}
                  deleteSpace={deleteSpaceById}
                  deleteItem={deleteItemById}
                ></SpaceComponent>
              );
            }
          )}
        <Line></Line>
        <AddSpaceButtonBox onClick={() => setOpenAddSpaceModal(true)}>
          <CustomButton
            width="100%"
            height="6vw"
            radius="5vw"
            size="2.6vw"
            text="+ 공간 추가하기"
          ></CustomButton>
        </AddSpaceButtonBox>
      </ContentsArea>

      {openAddSpaceModal && (
        <Backdrop>
          <AddSpaceModal
            onClose={onCloseAddSpaceModal}
            addNewSpace={addNewSpace}
          ></AddSpaceModal>
        </Backdrop>
      )}
    </>
  );
}
